import { RootState } from "../rootReducer";

export const patientListDataSelector = (state: RootState) => state.patientsListReducer.patientsPayload;
export const isGetPatientsLoadingSelector = (state: RootState) => state.patientsListReducer.isGetPatientsLoading;
